export const handleNumberToTwoDecimalPoint = (balance: number) => {
    let amount;
    if (balance && balance < 0) {
        amount = `($ ${Math.abs(balance)?.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})`
    }
    else {
        amount = `$ ${balance?.toLocaleString('en-Us', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    }
    return amount
}